<script lang="ts" setup>
import { useUserQuickComments } from "~/stores/useUserQuickComments";

const props = defineProps({
  quickComment: {
    type: Object as PropType<QuickComment>,
    required: true,
  },
  isInModal: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const emit = defineEmits(["saved"]);

const { saveQuickComment } = useUserQuickComments();

const isSaving = ref(false);

const save = async () => {
  isSaving.value = true;

  await saveQuickComment(props.quickComment);

  useBaseToast("Success! Comment saved.", "success");

  if (props.isInModal) {
    emit("saved");
    return;
  }

  isSaving.value = false;
};

const userQuickCommentsStore = useUserQuickComments();
const { categories } = storeToRefs(userQuickCommentsStore);

const handleCategoryCreated = (value: any) => {
  if (value.value) {
    props.quickComment.category = value.value;
    return;
  }

  props.quickComment.category = value;
};

const allCategories = computed(() => {
  if (props.quickComment.category) {
    return [...categories.value, props.quickComment.category];
  }

  return categories.value;
});

const cleanCategories = computed(() => {
  return allCategories.value.filter((category) => category != "");
});
</script>

<template>
  <div class="p-4 h-full flex flex-col min-h-0">
    <div class="flex flex-col grow min-h-0 overflow-auto">
      <BaseFormComponent>
        <template #label> Category </template>
        <!-- <BaseTextInput v-model="quickComment.category" /> -->
        <BaseSelectInput
          v-model="quickComment.category"
          @option-created="handleCategoryCreated"
          :options="cleanCategories"
          :allow-user-entered="true"
          :can-clear="true"
          placeholder="Select a category or type and press enter to create a new category"
        />
      </BaseFormComponent>
      <BaseFormComponent>
        <template #label> Levels </template>
        <LevelsSelect
          v-model="quickComment.levels"
          :is-multiple="true"
          class="w-full"
        />
      </BaseFormComponent>
      <BaseFormComponent>
        <template #label> Lessons </template>
        <LessonsSelect v-model="quickComment.lessons" :is-multiple="true" />
      </BaseFormComponent>
      <BaseFormComponent>
        <template #label> Comment </template>
        <BaseTextArea v-model="quickComment.comment" class="w-full h-[250px]" />
      </BaseFormComponent>
    </div>
    <div class="border-t pt-4">
      <BaseButton
        :show-spinner="isSaving"
        data-step-id="save-quick-comment-button"
        @click="save"
      >
        Save
      </BaseButton>
    </div>
  </div>
</template>

<style></style>
